import { TokenUid } from "@silo/types";
import { createLocalContext } from "../utils/create-local-context";

export const { TokenContext, useTokenContext } =
  createLocalContext<TokenUid>()("Token");
